import { render, staticRenderFns } from "./productDoc.vue?vue&type=template&id=61f121f1&scoped=true&"
import script from "./productDoc.vue?vue&type=script&lang=js&"
export * from "./productDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f121f1",
  null
  
)

export default component.exports